var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.121 1.378v4.816H2.405c-.222 0-.318.165-.35.264-.095.23-.063.494.064.626l3.464 3.596c.254.263.635.263.858 0l3.432-3.596c.127-.132.159-.396.095-.593-.063-.165-.222-.264-.413-.264h-1.78V1.41",
    stroke: "#fff",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M0 15.072h12"
  })));
};

export default SvgDownload;